var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.allChecked},on:{"change":_vm.onChangeInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }